import { render, staticRenderFns } from "./NavHeader.vue?vue&type=template&id=0abbdc22&scoped=true&"
import script from "./NavHeader.vue?vue&type=script&lang=js&"
export * from "./NavHeader.vue?vue&type=script&lang=js&"
import style0 from "./NavHeader.vue?vue&type=style&index=0&id=0abbdc22&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abbdc22",
  null
  
)

export default component.exports